import { Text } from "@certn/cascadia/foundations/typography/Text";
import { cssToken } from "@certn/cascadia/utils";
import { css, cx } from "@emotion/css";

import { IconPersonAvatar } from "../../avatar/IconPersonAvatar";
import { GhostIconButton } from "../../button/GhostIconButton";
interface Props {
  email: string;
  testID: string;
  onClick?: () => void;
}

export function Chip(props: Props) {
  const { email, testID } = props;

  return (
    <div data-testid={testID} className={cx(styles.chip)}>
      <IconPersonAvatar size="x-small" />
      <Text style="input/text-chip" color="text-base" truncate>
        {email}
      </Text>
      <GhostIconButton
        size="small"
        onPress={props.onClick}
        icon="close"
        testID={`remove-button-${testID}`}
      />
    </div>
  );
}

const styles = {
  chip: css({
    outline: "none",
    alignItems: "center",
    background: "transparent",
    borderRadius: 300,
    borderStyle: "solid",
    borderWidth: 0,
    display: "flex",
    flexDirection: "row",
    gap: "var(--space-1)",
    justifyContent: "center",
    backgroundColor: "var(--background-base)",
    "&[data-focus-visible]": { boxShadow: "var(--focus-action)" },
    "&[data-hovered]": {
      backgroundColor: "var(--background-ghost-hover)",
    },
    boxShadow: `inset 0px 0px 0px 1px ${cssToken("border-base")}`,
    paddingRight: "var(--space-3)",
    paddingLeft: "var(--space-1)",
    paddingTop: 0,
    paddingBottom: 0,
  }),
};
